export default "__VITE_ASSET__577cf952__"